import classNames from 'classnames';
import InfoTooltip from 'components/features/InfoTooltip';
import Typography from 'components/generics/texts/Typography';
import AnimateWhenVisible from 'components/transitions/AnimateWhenVisible';
import React, { HTMLAttributes, PropsWithChildren } from 'react';
import classes from './index.module.scss';

interface Props extends PropsWithChildren, HTMLAttributes<HTMLDivElement> {
  title?: string;
  subtitle?: string;
  subsubtitle?: string;
  saveHeights?: boolean;
  id?: string;
  titleInfo?: string;
  rightComponent?: React.ReactNode;
}

const BaseLandaFinancingSection = ({
  title,
  subtitle,
  subsubtitle,
  children,
  className,
  saveHeights = false,
  id,
  titleInfo,
  rightComponent,
}: Props) => {
  return (
    <AnimateWhenVisible className={classNames(classes.container, className)}>
      {(saveHeights || subsubtitle) && (
        <div className={classes.titleContainer}>
          <div className={classes.titleContainerLeft}>
            <Typography className={classes.title}>{title}</Typography>
            {titleInfo && id && (
              <InfoTooltip
                id={id}
                tooltipText={titleInfo}
              />
            )}
          </div>
          {rightComponent && rightComponent}
        </div>
      )}
      {(saveHeights || subtitle) && (
        <Typography className={classes.subtitle}>{subtitle}</Typography>
      )}
      {(saveHeights || subsubtitle) && (
        <Typography className={classes.subsubtitle}>{subsubtitle}</Typography>
      )}
      {children}
    </AnimateWhenVisible>
  );
};

export default BaseLandaFinancingSection;
